<template>
  <div id="app">
    <nav class="nav">
      <div class="nav-left">
        <div class="nav-item">
          <span style="margin-right: 15px" class="is-serif is-dark-grey is-boldest is-big-font">{{$name}}</span>
        </div>
        <div class="nav-item">
          <form class="web-search" :action="'https://query.' + $host + '/s'" target="_blank" method="get">
            <div class="input-wrapper">
              <i class="fas fa-search" />
              <input type="text" name="query" placeholder="Search the web..." class="input is-smaller-font is-dark-grey is-sanserif" autocomplete="off">
              <button type="submit">Search</button>
            </div>
            <input type="hidden" name="uid" :value="$userId">
            <input type="hidden" name="uc" :value="$userclass">
            <input type="hidden" name="source" :value="$source">
            <input type="hidden" name="i_id" :value="$implementationId">
            <input type="hidden" name="ap" :value="$adprovider">
            <input type="hidden" name="cid" :value="$host.split('.')[0].toLowerCase().replace(/^h/, '')">
            <input type="hidden" name="sbp" value="pwa">
          </form>
        </div>
      </div>
      <div class="nav-right">
        <a v-for="link in quicklinks" :key="link.key" :href="link.link" class="nav-item quicklink" target="_blank" @click="$impressions.sendEvent('ex_click', link.link)">
          <img :src="link.image" />
        </a>
      </div>
    </nav>
    <div class="labels">
      <button onclick="document.querySelector('.compose-wrapper').classList.add('open')" class="button is-danger"><i class="fas fa-plus"></i></button>
      <router-link class="label is-no-decoration is-lightest-grey is-sanserif is-small-font is-bold" title="Inbox" to="/f/inbox"><i class="fad fa-inbox"></i></router-link>
      <router-link class="label is-no-decoration is-lightest-grey is-sanserif is-small-font is-bold" title="Drafts" to="/f/draft"><i class="fad fa-pencil"></i></router-link>
      <router-link class="label is-no-decoration is-lightest-grey is-sanserif is-small-font is-bold" title="Sent" to="/f/sent"><i class="fad fa-paper-plane"></i></router-link>
      <router-link class="label is-no-decoration is-lightest-grey is-sanserif is-small-font is-bold" title="Spam" to="/f/spam"><i class="fad fa-exclamation-circle"></i></router-link>
      <router-link class="label is-no-decoration is-lightest-grey is-sanserif is-small-font is-bold" title="Trash" to="/f/trash"><i class="fad fa-trash"></i></router-link>
      <span class="sign-out is-no-decoration is-lightest-grey is-sanserif is-small-font is-bold" @click="signOut()"><i class="fad fa-sign-out-alt" /></span>
    </div>
    <router-view />
    <Compose />
  </div>
</template>

<script>
  import Compose from "./components/Compose";

  export default {
    components: { Compose },
    async beforeCreate() {
      if(await this.$gmail.user.isSignedIn()) {
        this.labels = await this.$gmail.labels.list();
        this.signedIn = await this.$gmail.user.isSignedIn();
      }
    },
    mounted() {
      const searchForm = document.querySelector('.web-search input[type=text]');

      searchForm.value = '';
      searchForm.focus();
      document.querySelector('.web-search').onsubmit = () => {
        if (searchForm.value.length < 1) return false;
        searchForm.value = '';
        searchForm.focus();
      }
      window.onclick = evt => {
        if (this.hasClass(evt.target, 'no-click')) return;
        searchForm.focus();
      }
    },
    methods: {
      hasClass(element, className) {
        while(element) {
          if (element.classList && element.classList.contains(className)) return true;
          element = element.parentNode;
        }
        return false;
      },
      signOut() {
        this.$gmail.user.signOut();
        this.$router.push('/login');
      }
    },
    data() {
      return {
        approvedLabels:['inbox','sent','trash','spam'],
        labels: [],
        signedIn:false,
        quicklinks:[
          {
            name:"Amazon",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/amazon_100.png",
            link:"https://amazon.com",
          },
          {
            name:"Email Support",
            image:"https://search.htheweathercenter.org/Content/Images/quicklinkIcons/hq/myemailsimplified.png",
            link:"https://myemailsimplified.com",
          },
          {
            name:"Walmart",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/walmart_100.png",
            link:"https://walmart.com",
          },
          {
            name:"Home Depot",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/homedepot_100.png",
            link:"https://homedepot.com",
          },
          {
            name:"JC Penney",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/jcpenney_100.png",
            link:"https://jcpenny.com",
          },
          {
            name:"Samsung",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/samsung_100.png",
            link:"https://samsung.com",
          },
          {
            name:"Weather",
            image:"https://search.htheweathercenter.org/Content/Images/quicklinkIcons/hq/weather.png",
            link:"https://theweatherchannel.com",
          },
          {
            name:"News",
            image:"https://search.htheweathercenter.org/Content/Images/quicklinkIcons/hq/news.png",
            link:"https://nbc.com",
          },
          {
            name:"Coupons",
            image:"https://search.htheweathercenter.org/Content/Images/quicklinkIcons/hq/coupons.png",
            link:"https://groupon.com",
          },
          {
            name:"Home Depot",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/homedepot_100.png",
            link:"https://homedepot.com",
          },
          {
            name:"JC Penney",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/jcpenney_100.png",
            link:"https://jcpenny.com",
          },
          {
            name:"Samsung",
            image:"https://autosuggest-files.s3.amazonaws.com/tiles/samsung_100.png",
            link:"https://samsung.com",
          },

        ]
      }
    }
  }
</script>

<style lang="less">
  @import "assets/base";

  .nav {
    .position(fixed, 0, 0, unset, 0);
    height: @navHeight;
    background-color: #fff;
    box-shadow:1px 1px 2px 1px rgba(0, 0, 0, 0.1);
    z-index: 10000;

    .nav-left, .nav-right {
      .position(absolute, 0, unset, 0, unset);
      height: @navHeight;

      &.nav-left {
        left:15px;
      }
      &.nav-right {
        right:15px;
      }
    }
    .nav-item {
      position: relative;
      display: inline-block;
      vertical-align: top;
      top:50%;
      transform: translateY(-50%);
      height: 42px;
      line-height: 42px;

      &.quicklink img {
        object-fit: cover;
        height: 42px;
        width: 42px;
        border-radius: @radius;
        box-shadow:1px 1px 3px 1px rgba(0, 0, 0, 0.2);
        cursor: pointer;
        margin-left:5px;

        &:hover {
          box-shadow:1px 1px 3px 1px rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
  .labels {
    .position(fixed, @navHeight, unset, 0, 0);
    width: @labelsWidth;
    border-right: 1px solid @borderColor;
    box-sizing: border-box;

    button {
      text-align: center;
      height: 38px;
      width: 38px;
      line-height: 38px;
      padding-left: 8px;
    }

    .label {
      position: relative;
      display: block;
      padding: 15px 20px;
      border-left: 4px solid transparent;
      transition: all 150ms linear;
      text-transform: capitalize;

      &:hover {
        color: rgba(0,0,50,.6);
        background-color: rgba(0,0,100,.1);
        border-color: rgba(100,100,200,.6);
      }
      &.router-link-active {
        color: rgba(0, 0, 50, .8);
        background-color: rgba(0, 0, 255, .1);
        border-color: rgba(0, 0, 255, .5);
      }
    }

    .sign-out {
      position: absolute;
      bottom:0;
      left:0;
      display: block;
      padding: 15px 20px;
      border-left: 4px solid transparent;
      transition: all 150ms linear;
      text-transform: capitalize;
      cursor: pointer;

      &:hover {
        color: rgba(0,0,50,.6);
        background-color: rgba(0,0,100,.1);
        border-color: rgba(100,100,200,.6);
      }

    }
  }
  .messages {
    padding-top: 40px;
    .position(fixed, @navHeight, unset, 0, @labelsWidth);
    width: @messagesWidth;
    border-right: 1px solid @borderColor;
    background-color: rgba(255,255,255,0.3);
    overflow-y: scroll;
    overflow-x: hidden;
    box-sizing: border-box;

    .folder {
      display: block;
      z-index: 100;
      .position(fixed, @navHeight, unset, unset, @labelsWidth);
      padding: 10px;
      width: @messagesWidth;
      background-color: rgba(255,255,255,0.8);
      line-height: 20px;
      box-sizing: border-box;
      border-bottom:1px solid @borderColor;
      border-right:1px solid @borderColor;
    }

    .message {
      display: block;
      padding: 10px 15px;
      border-bottom: 1px solid @borderColor;
      cursor: pointer;
      position: relative;
      -webkit-transition: all .15s linear;
      transition: all .15s linear;

      &:hover {
        background-color: rgba(0,0,0,.04);
      }

      &.router-link-exact-active {
        background-color: rgba(0,0,0,.07);
      }

      .from {
        display: block;
        margin: 0 0 3px;
      }
      .subject {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 5px;
      }
      .snippet {
        display: block;
        margin-bottom: 5px;
        max-height: 33px;
        overflow: hidden;
      }
      .date {
        display: block;
      }
    }
  }
  .viewer {
    .position(fixed, @navHeight, 0, 0, calc(@labelsWidth + @messagesWidth));
    white-space: normal;
    line-break: normal;

    .info {
      .position(absolute, 0, 0, unset, 0);
      background-color: #fafaff;
      padding: 10px 20px;
      box-sizing: border-box;
      border-bottom: 1px solid @borderColor;

      .subject {
        white-space: nowrap;
        margin-bottom: 3px;
      }
    }

    .frame {
      .position(absolute, 81px, 0, 0, 0);
      height: calc(100% - 60px);
      width: 100%;
      outline: none;
      border: none;
      background-color: #fff;
    }
  }

  .not-found {
    .position(fixed, 50%, 0, unset, @labelsWidth);
    text-align: center;
    transform: translateY(-50%);
  }
</style>
